import React, { useState } from "react";
import { createElementClass } from "../../helpers";
export var Tabs = function Tabs(_a) {
  var _b = _a.className,
      className = _b === void 0 ? "" : _b,
      _c = _a.active,
      active = _c === void 0 ? 0 : _c,
      children = _a.children;

  var _d = useState(active),
      activeTab = _d[0],
      setActiveTab = _d[1];

  var handleTabClick = function handleTabClick(index) {
    setActiveTab(index);
  };

  var renderHeader = function renderHeader(ch) {
    return React.Children.map(ch, function (child, index) {
      var c = child;
      return React.cloneElement(c, {
        key: index,
        label: c.props.label,
        parentCallback: handleTabClick,
        tabIndex: index,
        isActive: index === activeTab
      });
    });
  };

  var renderActiveTab = function renderActiveTab(ch) {
    return ch[activeTab] ? ch[activeTab].props.children : null;
  };

  var content = [].concat.apply([], children).filter(function (child) {
    return child !== null && child !== undefined;
  });
  return React.createElement("div", {
    className: createElementClass("tabs")
  }, React.createElement("ul", {
    className: createElementClass("tabs-header")
  }, renderHeader(content)), React.createElement("div", {
    className: createElementClass("tabs-content")
  }, renderActiveTab(content)));
};